// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".shared-node[data-v-ae21992a] {\n  width: 100%;\n  padding: 20px;\n}\n.shared-node .infoBox[data-v-ae21992a] {\n  width: 100%;\n  display: flex;\n  flex-wrap: wrap;\n  padding: 0 20px;\n  padding-bottom: 20px;\n}\n.shared-node .infoBox > div[data-v-ae21992a] {\n  width: 50%;\n  line-height: 30px;\n}", ""]);
// Exports
module.exports = exports;
